import React, { Component } from 'react';
import { withTranslations } from 'js/components/hocs/withTranslations';
import style from './index.scss';

export class Clock extends Component {
    onClick = () => {
        const { firstIndex, onClick } = this.props;

        onClick && onClick(firstIndex);
    };

    clock = React.createRef();

    componentDidUpdate(prevProps) {
        if (this.props.triggerShake !== prevProps.triggerShake) {
            const { current } = this.clock;

            if (current.className.includes(style.error)) {
                current.style.animation = 'none';
                current.style.webkitAnimation = 'none';

                // eslint-disable-next-line @babel/no-unused-expressions
                current.offsetHeight; /* trigger reflow */

                current.style.animation = null;
                current.style.webkitAnimation = null;
            }
        }
    }

    render() {
        const { type, segments, firstIndex, activeIndex, isError, isErrorPeriod, t } = this.props;
        const [second, first] = segments.slice(firstIndex - 1, firstIndex + 1);
        const isActiveClock = activeIndex === firstIndex || activeIndex === firstIndex - 1;
        const activeContainer = isActiveClock
            ? style.active
            : '';
        const firstItemClasses = first !== 0
            ? style.activeNumber
            : '';
        const secondItemClasses = second !== 0 || first !== 0
            ? style.activeNumber
            : '';
        const errorClasses = activeIndex % 2 !== 0 && (isError || isErrorPeriod)
            ? style.error
            : '';

        return (
            <div ref={this.clock}
                className={`${style.clock} ${errorClasses}`}
                onClick={this.onClick}>
                <div className={style.label}>
                    {t(`playtech.mobile.system.dp.clock.label.${type}`)}
                </div>
                <div className={activeContainer}>
                    {activeIndex !== firstIndex - 1 && <span className={firstItemClasses}>{first}</span>}
                    <span className={secondItemClasses}>{second}</span>
                </div>
            </div>
        );
    }
}

export default withTranslations(Clock);
